import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  PROFILE_SETTINGS_PERMISSIONS,
} from '@modules/profile-settings/constants';
import { useToastStore } from '@modules/toast/store';

import type {
  IProfileSettingsChangePasswordPayload,
} from '../types';
import {
  ADMIN_PROFILE_SETTINGS_CHANGE_PASSWORD_SAVE_URL,
  AFFILIATE_PROFILE_SETTINGS_CHANGE_PASSWORD_SAVE_URL,
  PROFILE_SETTINGS_CHANGE_PASSWORD_SAVE_MUTATION_KEY,
} from '../constants';

export default function useProfileSettingsChangePasswordMutation(): IContextMutationResult<
  void,
  Error,
  IProfileSettingsChangePasswordPayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<void, Error, IProfileSettingsChangePasswordPayload>({
    mutationKey: [PROFILE_SETTINGS_CHANGE_PASSWORD_SAVE_MUTATION_KEY],
    mutationFn: (payload) => fetchPut<void>(
      isAdminNamespace.value ? ADMIN_PROFILE_SETTINGS_CHANGE_PASSWORD_SAVE_URL : AFFILIATE_PROFILE_SETTINGS_CHANGE_PASSWORD_SAVE_URL,
      payload,
      {
        permission: PROFILE_SETTINGS_PERMISSIONS.EDIT,
      },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
